import { observer } from 'mobx-react-lite';
import { useNotificationsStore } from './NotificationsStore';
import GapDialog from 'reusable/gap-dialog/GapDialog';

export default observer(function NotificationDialog() {
   const notificationsStore = useNotificationsStore()

   return <GapDialog
      size="small"
      title="Notification"
      modalState={notificationsStore.notificationModalState}
   >
      {notificationsStore.notificationDialogComponent && <notificationsStore.notificationDialogComponent />}
   </GapDialog>
})
